import { Toaster } from 'react-hot-toast'
import { RouterProvider } from 'react-router'
import { ToastBar } from '@/components/ui/toast-bar'
import { useMediaQuery } from '@/hooks/use-media-query'
import router from './router.tsx'

/**
 * The session probes used to live here, which meant every route waited on the
 * Luminate one. They are routes now, one per section (`LuminateSessionRoute`,
 * `MarqueeSessionRoute`), so each tree waits only on the identity it reads.
 */
export default function App() {
	const isDesktop = useMediaQuery({ breakpoint: 'md' })

	return (
		<>
			<Toaster
				position={isDesktop ? 'bottom-right' : 'bottom-center'}
				toastOptions={{
					success: {
						iconTheme: {
							primary: 'var(--color-green-600)',
							secondary: 'var(--color-neutral-white)'
						}
					}
				}}
			>
				{(toast) => <ToastBar t={toast} />}
			</Toaster>
			<RouterProvider router={router} />
		</>
	)
}
